import Svg, { G, Mask, Path, Text, TSpan } from 'react-native-svg'

export const JioPayLightDarkBg = ({ color = '#0F3CC9', textColor = '#fff' }: any) => {
  return (
    <Svg id="Logo-on-dark" width="152" height="32" viewBox="0 0 152 32">
      <Mask
        id="a"
        width={32}
        height={32}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}>
        <Path fill="#fff" d="M32 0H0v32h32V0Z" />
      </Mask>
      <G mask="url(#a)">
        <Path fill={color} d="M32 15.999a16 16 0 1 1-32 0 16 16 0 0 1 32 0Z" />
        <Path
          fill="#fff"
          d="M14.935 26.257a3.06 3.06 0 0 1-.762-.3l-1.372-.795v-3.55a1.068 1.068 0 0 0-2.134 0v2.322l-2.37-1.373a4.05 4.05 0 0 1-1.83-3.168v-6.781a4.05 4.05 0 0 1 1.83-3.173l5.875-3.391c.562-.3 1.192-.45 1.829-.436a3.718 3.718 0 0 1 1.829.436l5.875 3.392a4.049 4.049 0 0 1 1.83 3.172v6.785a4.05 4.05 0 0 1-1.828 3.168l-2.371 1.369v-9.922a1.067 1.067 0 1 0-2.134 0v11.15l-1.37.791c-.24.134-.496.235-.762.3v-8.428a1.067 1.067 0 1 0-2.134 0l-.001 8.432Z"
        />
      </G>
      <Text
        id="JioPay_Business"
        data-name="JioPay Business"
        transform="translate(40 21)"
        fill={textColor}
        fontSize="14"
        fontFamily="JioType-Bold, JioType"
        fontWeight="700">
        <TSpan x="0" y="0">
          Jio
        </TSpan>
        <TSpan y="0" letter-spacing="-0.03em">
          P
        </TSpan>
        <TSpan y="0">ay </TSpan>
        <TSpan y="0" fontFamily="JioType-Bold, JioType" fontWeight="700">
          Business
        </TSpan>
      </Text>
    </Svg>
  )
}
